export default __webpack_public_path__ + "static/media/bg-sign-up-blue.35a3ff91.jpg";